<template>
  <div class="row">
    <div class="col">
      <card-container
              :title="$router.currentRoute.meta.title"
              :headers="tableHeaders"
              :lastPage="lastPage"
              :totalElements="totalElements"
              :currentPage="getCurrentPage()"
              :clickHandler="pagination">

        <template v-slot:card-header>
          <router-link :to="{ name: `${routePrefix}.create`}" class="btn btn-primary btn-sm" v-can:add="permissionPrefix">
            <i class="fa fa-plus"></i>
          </router-link>
        </template>

        <template v-slot:table-rows>
          <tr v-for="(item,index) in items" :key="item.id">
            <td>
              <div class="media align-items-center">
                <a v-if="getImageThumbnail(item)" href="javascript:;" class="avatar rounded-circle">
                  <img alt="Image placeholder" :src="getImageThumbnail(item)">
                </a>
                <div class="media-body">
                  <span class="name mb-0 text-sm"></span>
                </div>
              </div>
            </td>
            <td> {{ item.name }} </td>
            <td> {{ item.email }} </td>
            <table-item-actions :actions="tableItemActions" :params="{'id':item.id}">
              <template v-slot:additional-items>
                <roles-action v-model="activeParams" :itemID="item.id" :index="index" :successCallback="getList" v-can:view="permissionPrefix"/>
                <table-item-actions-delete :options="deleteOptions" :params="{'id':item.id}" />
              </template>
            </table-item-actions>
          </tr>
          <tr class="text-center" v-if="!items.length">
            <td colspan="999">{{ $t('messages.no_result_found')}}</td>
          </tr>
        </template>
      </card-container>
      <roles-action-modal :activeParams="activeParams" v-can:view="permissionPrefix"/>
    </div>
  </div>
</template>
<script>

  import { USERS_LIST as CRUD_ACTION_LIST, USERS_DELETE as CRUD_ACTION_DELETE } from 'actions/users';
  import rolesAction from "./actions/roles";
  import rolesActionModal from "./actions/modals/roles";
  const CRUD_CODE="users";
  const CRUD_PERMISSION_CODE=`${CRUD_CODE}`;
  export default {
    name: "UsersIndex",
    components:{
      rolesAction,
      rolesActionModal,
    },
    data(){
      return {
        routePrefix: CRUD_CODE,
        transPrefix: CRUD_CODE,
        permissionPrefix: CRUD_PERMISSION_CODE,
        tableHeaders:[
          {
            'title':`fields.image`
          },
          {
            'title':`fields.name`
          },
          {
            'title':`fields.email`
          },
          {
            'title':`fields.actions`
          }
        ],
        tableItemActions:[
          {
            code:'show',
            route_name:`${CRUD_CODE}.show`,
            can:`${CRUD_PERMISSION_CODE}_can_view`,
          },
        ],
        items: [],
        perPage:20,
        totalElements:0,
        lastPage:0,
        activeParams:{},
        deleteOptions: {
          code:'delete',
          can:`${CRUD_PERMISSION_CODE}_can_delete`,
          action:CRUD_ACTION_DELETE,
          successCallback:this.getList
        },
      }
    },
    mounted() {
      this.getList();
    },
    methods: {
      getList(){
        this.$store.dispatch(CRUD_ACTION_LIST,{
          pageId: this.getCurrentPage()-1,
        }).then(response=>{
          this.items=response.data.data;
          this.perPage=response.data.perPage;
          this.totalElements=response.data.totalElements;
          this.lastPage=response.data.pageCount;
        });
      },
      pagination(page){
        if(page!== this.getCurrentPage()){
          this.$router.push({
            name: `${this.routePrefix}.index`,
            query:{
              page
            }
          });
          this.getList();
        }
      },
      getCurrentPage(){
        let currentPage=this.$route.query.page??1;
        return parseInt(currentPage>=1?currentPage:1);
      },
      getImageThumbnail(item){
        return item.profilePicture ? item.profilePicture.url : require('../../assets/theme/img/theme/avatar.png');
      }
    }
  };
</script>
